// base
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// App
import App from './App.jsx';

// css
import '@fontsource-variable/noto-sans-kr';

// contexts
import { AlertProvider, NotificationProvider } from 'contexts';

// variables
import { themeOptions } from 'variables';

// libraries
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { RecoilRoot } from 'recoil';
import { ConfigProvider } from 'antd';
import koKR from 'antd/lib/locale/ko_KR';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);
dayjs.locale('ko');

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <RecoilRoot>
      <ConfigProvider theme={themeOptions} locale={koKR}>
        <NotificationProvider>
          <AlertProvider>
            <App />
          </AlertProvider>
        </NotificationProvider>
      </ConfigProvider>
    </RecoilRoot>
  </BrowserRouter>
);
